// extracted by mini-css-extract-plugin
export default {"player":"SummaryPlayer_player__XepFB","wrapper":"SummaryPlayer_wrapper__UDmF6"};